import React, { useState, useEffect } from "react";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import Comment from "./Comment";
import CreateComment from "./CreateComment";
import Button from "components/CustomButton";
import { useLocation } from "react-router-dom";
import { ExpressionsContext } from "store/contexts/expressionsContext";
import { useUserContext } from "store/contexts/userContext";
import { useTimelineContext } from "store/contexts/timelineContext";

export default ({ post }) => {
  const { user } = useUserContext();
  const [expressions, setExpressions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);
  const location = useLocation();
  const search = location.search;
  const param = new URLSearchParams(search);
  const [expression_id, setExpressionId] = useState(
    param.get("expression_id") ?? null
  );
  const [reply_id, setReplyId] = useState(param.get("reply_id") ?? null);
  const { updatePost, innovation_dashboard, company_id } = useTimelineContext();

  useEffect(() => {
    if (expression_id) {
      setExpressionId(param.get("expression_id"));
    }

    if (reply_id) {
      setReplyId(param.get("reply_id"));
    }
    //eslint-disable-next-line
  }, [search, param]);

  useEffect(() => {
    setIsLoading(true);
    if (expression_id && expressions.length !== 0) {
      setExpressions([]);
    }

    (async () => {
      try {
        if (!expression_id || expression_id === "undefined") {

          let response;

          if (innovation_dashboard)
            response = await TeamService.getCompanyExpressionList(
              company_id,
              post.id,
              { page: page }
            );


          if (!innovation_dashboard)
            response = await TeamService.getExpressionList(
              post.team_id,
              post.id,
              { page: page }
            );


          setIsLoading(false);
          setMeta(response.data.meta);
          setExpressions(
            Array.from(new Set([...expressions, ...response.data.data]))
          );
          return;
        }

        let response;
        if (innovation_dashboard)
          response = await TeamService.getSingleCompanyExpression(
            company_id,
            post.id,
            expression_id
          );


        if (!innovation_dashboard)
          response = await TeamService.getSingleExpression(
            post.team_id,
            post.id,
            expression_id
          );
        setIsLoading(false);
        setMeta(0);
        setExpressions([response.data.data]);
      } catch (e) {
        console.log(e);
      }
    })();

    // eslint-disable-next-line
  }, [post.id, post.team_id, page, expression_id]);

  const createExpression = (expression) => {
    setExpressions(Array.from(new Set([expression, ...expressions])));
  };

  const viewMore = () => {
    if (!expression_id) {
      setPage(page + 1);
      return;
    }
    setExpressionId(null);
    setReplyId(null);
    setExpressions([]);
  };

  const deleteExpression = (newExpression) => {
    var newExpressions = expressions.filter(
      (expressions) => expressions.id !== newExpression.id
    );

    var userExpressionExist = newExpressions.some(
      (expression) => expression?.user?.id === user?.id
    );

    if (!userExpressionExist) {
      const postCopy = { ...post };

      postCopy.expressions_count -= 1;
      postCopy.user_expressed = false;

      updatePost(postCopy);
    }

    setExpressions(newExpressions);
  };

  const updateExpression = (expression) => {
    const expressionCopy = [...expressions];

    expressionCopy[
      expressionCopy.findIndex((tExpression) => {
        return tExpression.id === expression.id;
      })
    ] = {
      ...expression,
    };

    setExpressions(expressionCopy);
  };

  return (
    <ExpressionsContext.Provider
      value={{
        updateExpression,
        createExpression,
        deleteExpression,
        reply_id,
        setReplyId,
      }}
    >
      <div className="post_comments-section">
        <CreateComment post={post} />
        <div>
          {expressions.map((expression) => (
            <Comment
              expression={expression}
              key={expression.id}
              post={post}
              expression_id={expression_id}
            />
          ))}
          {expression_id && expression_id !== "undefined" && !isLoading && (
            <div className="viewAllButton">
              <Button buttonClass={"grad_btn join-btn"} onClick={viewMore}>
                View All
              </Button>
            </div>
          )}
          {page !== meta?.last_page && !isLoading && !expression_id && (
            <div className="viewAllButton">
              <Button
                buttonClass={"grad_btn join-btn"}
                onClick={() => setPage(page + 1)}
              >
                Load More
              </Button>
            </div>
          )}
          {isLoading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Loader />
            </div>
          )}
        </div>
      </div>
    </ExpressionsContext.Provider>
  );
};
